import { BasePropertyDTO } from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import { useEffect, useState } from 'react';

export interface useFetchPlateNodeCustomNamePropertyProps {
  experimentId: number;
}

export const useFetchPlateNodeCustomNameProperty = (
  props: useFetchPlateNodeCustomNamePropertyProps,
) => {
  const { experimentId } = props;
  const [plateNodeNameFormatProperty, setPlateNodeNameFormatProperty] =
    useState<BasePropertyDTO>();

  useEffect(() => {
    const fetchUserProperty = async () => {
      try {
        const preferencesService = new GlobalPreferencesService();
        const plateNodeFormatProperty: BasePropertyDTO =
          await preferencesService.getUserProperty('ExperimentPlate.TreeNode.CustomName');

        setPlateNodeNameFormatProperty(plateNodeFormatProperty);
      } catch (error) {
        console.error('Error fetching user property:', error);
      }
    };

    fetchUserProperty();
  }, [experimentId]);

  return plateNodeNameFormatProperty;
};
